import Aside from "../Component/Aside";
import Content from "../Component/Content";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

export default function Welcome() {
    return <>
        <Header />
        <Aside />
        <Content />
        <Footer />
    </>
}